module.exports = __webpack_public_path__ + "img/shopbase-two-en.d2d8bc7a.png";